var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{staticClass:"mb-2"},_vm._l((_vm.opciones),function(route){return _c('v-tab',{key:route.name,attrs:{"to":`/controles/equipo${route.url}`}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(route.icon))]),_vm._v(" "+_vm._s(route.name)+" ")],1)}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }